export const authTranslations = {
  ar: {
    title: 'SmartAccount ERP',
    subtitle: 'نظام محاسبي ومالي ومخازن متكامل',
    welcome: 'مرحباً بك',
    loginTitle: 'تسجيل الدخول',
    username: 'اسم المستخدم',
    password: 'كلمة المرور',
    usernamePlaceholder: 'أدخل اسم المستخدم',
    passwordPlaceholder: 'أدخل كلمة المرور',
    login: 'تسجيل الدخول',
    loggingIn: 'جاري تسجيل الدخول...',
    usernameRequired: 'هذا الحقل مطلوب',
    passwordRequired: 'هذا الحقل مطلوب',
    emailInvalid: 'يرجى إدخال بريد إلكتروني صحيح',
    invalidCredentials: 'اسم المستخدم أو كلمة المرور غير صحيحة',
    rememberMe: 'تذكرني',
    forgotPassword: 'نسيت كلمة المرور؟',
    success: 'تم تسجيل الدخول بنجاح',
    error: 'فشل تسجيل الدخول',
    auditTitle: 'تسجيل الدخول - وضع التدقيق الخارجي',
    auditTokenPlaceholder: 'أدخل رمز التدقيق',
    auditLoading: 'جاري تسجيل الدخول...',
    auditSuccess: 'تم تسجيل الدخول بنجاح',
    auditError: 'فشل تسجيل الدخول',
    auditInvalidToken: 'رمز التدقيق غير صالح أو منتهي الصلاحية',
    auditReadOnlyMode: 'وضع القراءة فقط - لا يمكنك تعديل البيانات',
    auditMessage: 'يجب أن يكون لديك رابط تدقيق صالح للوصول إلى النظام',
    logout: 'تسجيل الخروج',
    profile: 'الملف الشخصي',
    changePassword: 'تغيير كلمة المرور',
    forgotPasswordSent: 'سيتم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني قريباً',
    forgotPasswordError: 'حدث خطأ أثناء إرسال رابط إعادة التعيين',
    loginActivity: 'تسجيل دخول المستخدم: ',
  },
  en: {
    title: 'SmartAccount ERP',
    subtitle: 'Integrated Accounting, Finance & Inventory System',
    welcome: 'Welcome',
    loginTitle: 'Login',
    username: 'Username',
    password: 'Password',
    usernamePlaceholder: 'Enter username',
    passwordPlaceholder: 'Enter password',
    login: 'Login',
    loggingIn: 'Logging in...',
    usernameRequired: 'This field is required',
    passwordRequired: 'This field is required',
    emailInvalid: 'Please enter a valid email address',
    invalidCredentials: 'Invalid username or password',
    rememberMe: 'Remember me',
    forgotPassword: 'Forgot password?',
    success: 'Login successful',
    error: 'Login failed',
    auditTitle: 'Login - External Audit Mode',
    auditTokenPlaceholder: 'Enter audit token',
    auditLoading: 'Logging in...',
    auditSuccess: 'Login successful',
    auditError: 'Login failed',
    auditInvalidToken: 'Invalid or expired audit token',
    auditReadOnlyMode: 'Read-Only Mode - You cannot modify data',
    auditMessage: 'You must have a valid audit link to access the system',
    logout: 'Logout',
    profile: 'Profile',
    changePassword: 'Change Password',
    forgotPasswordSent: 'Password reset link will be sent to your email soon',
    forgotPasswordError: 'An error occurred while sending reset link',
    loginActivity: 'User login: ',
  },
  fr: {
    title: 'SmartAccount ERP',
    subtitle: 'Système intégré de comptabilité, finance et inventaire',
    welcome: 'Bienvenue',
    loginTitle: 'Connexion',
    username: 'Nom d\'utilisateur',
    password: 'Mot de passe',
    usernamePlaceholder: 'Entrez le nom d\'utilisateur',
    passwordPlaceholder: 'Entrez le mot de passe',
    login: 'Connexion',
    loggingIn: 'Connexion...',
    usernameRequired: 'Ce champ est requis',
    passwordRequired: 'Ce champ est requis',
    emailInvalid: 'Veuillez entrer une adresse e-mail valide',
    invalidCredentials: 'Nom d\'utilisateur ou mot de passe incorrect',
    rememberMe: 'Se souvenir de moi',
    forgotPassword: 'Mot de passe oublié ?',
    success: 'Connexion réussie',
    error: 'Échec de la connexion',
    auditTitle: 'Connexion - Mode audit externe',
    auditTokenPlaceholder: 'Entrez le jeton d\'audit',
    auditLoading: 'Connexion...',
    auditSuccess: 'Connexion réussie',
    auditError: 'Échec de la connexion',
    auditInvalidToken: 'Jeton d\'audit invalide ou expiré',
    auditReadOnlyMode: 'Mode lecture seule - Vous ne pouvez pas modifier les données',
    auditMessage: 'Vous devez avoir un lien d\'audit valide pour accéder au système',
    logout: 'Déconnexion',
    profile: 'Profil',
    changePassword: 'Changer le mot de passe',
    forgotPasswordSent: 'Un lien de réinitialisation sera bientôt envoyé à votre e-mail',
    forgotPasswordError: 'Une erreur s\'est produite lors de l\'envoi du lien',
    loginActivity: 'Connexion utilisateur : ',
  },
}


